import React from "react";
import { formatAbsolute } from "../utils/datetime";

const STARS = [1, 2, 3, 4, 5];

// As cinco estrelas de uma avaliacao, cheias ate a nota. O cartao abaixo e as linhas da lista de
// conversas desenham-nas aqui, para se lerem como a mesma coisa; o leitor de ecra ouve a frase, e nao
// cinco simbolos.
export const CsatStars = ({ rating, translate, className, title }) => (
  <span className={className} role="img" aria-label={translate("conversationsCsatStarsLabel", { n: rating })} title={title}>
    {STARS.map((n) => (
      <span
        key={n}
        data-star={n <= rating ? "filled" : "empty"}
        style={{ color: n <= rating ? "var(--color-warning)" : "var(--color-border)" }}
        aria-hidden="true"
      >
        ★
      </span>
    ))}
  </span>
);

// O cartao da avaliacao que o cliente deu no fim da conversa. Sem avaliacao nao
// ha cartao (decidido pelo Tiago a 2026-10-15: quando o cliente nao avalia, nao
// se mostra): nem "ainda sem avaliacao" nem "avaliacao pedida", e um backend
// antigo que nao manda o campo le-se da mesma maneira, porque nao ha nada para
// desenhar.
//
// O comentario e texto do cliente: vai em `<p>` como filho de texto, nunca como
// HTML.
const ConversationCsat = ({ csat, translate, language }) => {
  if (!csat) return null;

  return (
    <div
      className="w-full min-w-0 mt-1 flex flex-col gap-1 rounded-lg px-3 py-2"
      style={{ backgroundColor: "var(--color-surface-raised)", border: "1px solid var(--color-border)" }}
    >
      <p className="text-xs font-medium" style={{ color: "var(--color-text-secondary)" }}>
        {translate("conversationsCsatTitle")}
      </p>
      <CsatStars
        rating={csat.rating}
        translate={translate}
        className="text-base leading-5"
        title={formatAbsolute(csat.submitted_at, language)}
      />
      {typeof csat.comment === "string" && csat.comment && (
        <p className="text-[13px] leading-[18px] whitespace-pre-wrap break-words" style={{ color: "var(--color-text-primary)" }}>
          {csat.comment}
        </p>
      )}
      {csat.operator_name && (
        <p className="text-xs" style={{ color: "var(--color-text-secondary)" }}>
          {translate("conversationsCsatHandledBy", { name: csat.operator_name })}
        </p>
      )}
    </div>
  );
};

export default ConversationCsat;
